import { GrAttachment } from 'react-icons/gr';
import { IoIosSend } from 'react-icons/io';
import useChatbotStore from '@stores/chatbotStore';
import { useState, useRef } from 'react';
import { cn } from '@helpers/styleUtils';
import { is } from 'date-fns/locale';

export const ChatFooter = () => {
    const [message, setMessage] = useState('');
    const fileInputRef = useRef(null);

    const { sendMessage, isLoading, uploadFile } = useChatbotStore();

    const handleSendMessage = async () => {
        if (!message.trim() || isLoading) return;
        document.getElementById('message-input').value = '';
        await sendMessage(message);
        setMessage('');
    };

    const handleKeyPress = e => {
        if (isLoading) {
            document.getElementById('message-input').value = '';
            return;
        }
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    const handleFileUpload = async e => {
        if (isLoading) return;
        const file = e.target.files[0];
        const extractedSpeed = await uploadFile(file);
        if (extractedSpeed) {
            setMessage(extractedSpeed);
        }
    };

    return (
        <div className="h-16 flex items-center justify-between border-t border-slate-200">
            <div
                className="flex items-center justify-center border-r border-slate-200 w-2/12 text-2xl cursor-pointer text-gray-600 hover:text-gray-800 h-full"
                onClick={() => fileInputRef.current?.click()}
            >
                <GrAttachment />
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={handleFileUpload}
                />
            </div>
            <div className="flex items-center justify-center w-8/12 text-base cursor-pointer h-full">
                <textarea
                    id="message-input"
                    placeholder="Enter your message..."
                    className={cn(
                        'w-full h-full outline-none pl-4 pr-2 resize-none no-scrollbar',
                        isLoading && 'bg-gray-100 text-gray-500 cursor-not-allowed',
                    )}
                    onChange={e => setMessage(e.target.value)}
                    onKeyDown={handleKeyPress}
                    onKeyUp={handleKeyPress}
                />
                {/* <input
                    id="message-input"
                    type="text"
                    onChange={e => setMessage(e.target.value)}
                    onKeyDown={handleKeyPress}
                    placeholder="Write a message..."
                    className="w-full h-full outline-none pl-4 pr-2"
                    disabled={isLoading}
                /> */}
            </div>
            <div
                onClick={handleSendMessage}
                className={cn("flex items-center justify-center w-2/12 text-3xl cursor-pointer text-blue-600 hover:text-blue-800 h-full",isLoading && 'cursor-not-allowed')}
            >
                <IoIosSend />
            </div>
        </div>
    );
};
